import { render, staticRenderFns } from "./TermsPolicy.vue?vue&type=template&id=f1feed7e&scoped=true"
import script from "./TermsPolicy.vue?vue&type=script&lang=js"
export * from "./TermsPolicy.vue?vue&type=script&lang=js"
import style0 from "./TermsPolicy.vue?vue&type=style&index=0&id=f1feed7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1c848d52c9dbe574bb8312e4e1e1d32e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1feed7e",
  null
  
)

export default component.exports